import React, { Component } from 'react';

import logo from '../../assets/logo.svg'
import logoBlue from '../../assets/images/logo_blue.svg'

import profileImage from '../../assets/profile.jpg'
import { Link } from 'react-router-dom';


import "./Header.css"

class Header extends Component {

  state = {
    responsive: false,
    classNames: {
      index: '',
      summary: ''
    }
  }

  navFunction = () => {

    this.setState({
      responsive: !this.state.responsive
    })
  }

  render() {


    return (
      <React.Fragment>

        <header>
          <div className="main">
            <div className="logo">
              <img src={logo} alt="SkyGenic Logo" />
            </div>

            <ul className="main_toggle">
              <li><Link to="#" className="dropdown">Storage</Link></li>
              <li className="selected"><Link to="#" className="dropdown">Projects</Link>
                <ul>
                  <li><Link to='/'>My SkyGenic Project</Link></li>
                  <li><Link to='/'>RNA Project</Link></li>
                  <li><Link to='/'>All Projects</Link></li>
                </ul>
              </li>
            </ul>

            <div className="profile">
              <button type="button" id="profile" className="dropdown">Odie</button>
              <img src={profileImage} alt="profile" />
              <ul>
                <li><img src={logoBlue} alt="SkyGenic Logo" /></li>
                <li><strong>Hello Sarah Jacobs.</strong></li>
                <li><a href="skygenic#!/user_profile">Edit My Profile</a></li>
                <li><a href="logout">Log Out</a></li>
                <li className="small">
                  <a href="https://skygenic.com/privacy/" target="_blank" rel='noreferrer'>Privacy Policy</a>
              •
              <a href="https://skygenic.com/terms/" target="_blank" rel='noreferrer'>Terms of Service</a>
              •
              <a href="https://skygenic.com/hipaa-business-associate-agreement/" target="_blank" rel='noreferrer'>BAA Agreement</a>
                </li>
              </ul>
            </div>
          </div>
        </header>
      </React.Fragment>
    )
  }
}

export default Header